
import { CustomAppLayout } from '../../../layout';
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useState } from 'react';
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';
const _preserve = React.version;


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Box, Button, Checkbox, FormField, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import * as XLSX from "xlsx";
import Favorites from '../../../../../components/extras/Favorites';
import SelectUser from '../../../../../components/selects/selectUser';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemUser } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, getUser, setData, setLoading, setParameters } from '../../../../commons/functions';

export const DownloadsUser = () => {
    const { data, menu, parameters } = useGlobalState();
    const [selectedOptions, setSelectedOptions] = useState([]);
    const options = [
        { text: 'Movimientos', value: 'movements' },
        { text: 'Bitácoras', value: 'flights' },
        { text: 'Reservas', value: 'bookings' },
        { text: 'Chequeos', value: 'checks' },
        { text: 'Mantenimiento', value: 'mants' },
        { text: 'Cargos', value: 'charges' },
        { text: 'Grupos', value: 'groups' },
    ]

    const handleGetUser = async () => {
        //if (parameters.startDate && parameters.endDate) {
        if (parameters.period) {

            try {
                setLoading(true)
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/reports/users/user',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify({
                        idUser: parameters.idUser,
                        attributes: selectedOptions,

                    }),
                    //mode: 'no-cors'  // Bypasses CORS but limits the response
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const dataWeb = await response.json();
                addNotificationStatus(dataWeb, setData);
                if (dataWeb.code == 0) {
                    console.log(dataWeb.report)

                    const exportToExcel = () => {
                        const wb = XLSX.utils.book_new();
                        const reports = dataWeb.report;
                        Object.entries(reports).forEach(([key, value]: [string, any]) => {
                            const matchedOption = options.find(opt => opt.value === key);
                            const sheetName = matchedOption ? matchedOption.text : key;
                            const ws = XLSX.utils.json_to_sheet(value || []);
                            XLSX.utils.book_append_sheet(wb, ws, sheetName);
                        });
                        XLSX.writeFile(wb, `${parameters.idUser}-${getUser(parameters.idUser, data).displayName}.xlsx`);
                    };
                    exportToExcel();
                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally { setLoading(false) }

        };
    }


    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />}>Ficha de usuario</Header>
                    <SpaceBetween size="s" direction="vertical">
                        <FormField label="Usuario">
                            <SelectUser value={parameters.idUser} onConfirm={(newIdUser: ItemUser) => {
                                if (newIdUser)
                                    setParameters({ ...parameters, idUser: newIdUser.idUser });
                            }} />
                        </FormField>
                        <FormField label="Atributos">
                            <SpaceBetween size="s" direction="horizontal">
                                {options.map((option) => (
                                    <Checkbox key={option.value} checked={selectedOptions.includes(option.value)} onChange={({ detail }) => {
                                        const newSelectedOptions = detail.checked ? [...selectedOptions, option.value] : selectedOptions.filter((value) => value !== option.value);
                                        setSelectedOptions(newSelectedOptions);
                                    }}>
                                        {option.text}
                                    </Checkbox>
                                ))}
                            </SpaceBetween>
                        </FormField>
                        <Box float="right">
                            <Button
                                disabled={!parameters.idUser || selectedOptions.length === 0}
                                variant="primary" onClick={() => {
                                    handleGetUser();
                                }}>Generar</Button>
                        </Box>
                    </SpaceBetween>

                </SpaceBetween>
            }
        />
    )
};
